module.exports = __webpack_public_path__ + "media/LandingPageAssets/MaskGroup1-8ba3380b.png";